"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _Button = _interopRequireDefault(require("../Button"));
var _reactI18next = require("react-i18next");
var _eventDispatcher = _interopRequireWildcard(require("../../util/eventDispatcher"));
var _CouponInputStyled = require("./CouponInputStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "m23.954 21.03-9.184-9.095 9.092-9.174L21.03-.046l-9.09 9.179L2.764.045l-2.81 2.81L9.14 11.96.045 21.144l2.81 2.81 9.112-9.192 9.18 9.1z"
    })
  });
};
CloseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
};
const CouponInput = _ref => {
  let {
    value,
    fullWidth,
    couponDetails,
    onSubmit,
    onChange,
    onInputToggle,
    couponLoading,
    source
  } = _ref;
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [isFocused, setIsFocused] = (0, _react.useState)(false);
  const [showCouponMessage, setShowCouponMessage] = (0, _react.useState)(false);
  const inputRef = (0, _react.useRef)(null);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    showMessage,
    message,
    messageType,
    translationKey
  } = couponDetails;
  const handleRedeem = async () => {
    if (!isOpen) {
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_REDEEM_COUPON_BUTTON_CLICKED, {
        source
      });
      if (onInputToggle) onInputToggle();
      setIsOpen(true);
    } else {
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_REDEEM_BUTTON_CLICKED, {
        coupon: value,
        source
      });
      await onSubmit(value);
    }
  };
  const handleClose = () => {
    if (isOpen) {
      setIsOpen(false);
      if (onInputToggle) onInputToggle();
      onChange('');
    }
  };
  (0, _react.useEffect)(() => {
    if (showMessage) {
      setIsOpen(true);
      setShowCouponMessage(true);
    }
  }, [showMessage]);
  (0, _react.useEffect)(() => {
    if (value === '') setShowCouponMessage(false);
  }, [value]);
  (0, _react.useEffect)(() => {
    setShowCouponMessage(showMessage);
  }, [showMessage]);
  (0, _react.useEffect)(() => {
    if (inputRef.current) inputRef.current.focus();
  }, [isOpen]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CouponInputStyled.FormComponentStyled, {
    $isOpen: isOpen,
    $fullWidth: fullWidth,
    onSubmit: async e => {
      e.preventDefault();
      await handleRedeem();
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_CouponInputStyled.InputElementWrapperStyled, {
      $isFocused: isFocused,
      children: [isOpen && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CouponInputStyled.CloseButtonStyled, {
          type: "button",
          "aria-label": "close",
          onClick: handleClose,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(CloseIcon, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CouponInputStyled.InputElementStyled, {
          type: "text",
          placeholder: t('coupon-input.placeholder', 'Your coupon'),
          autoComplete: "off",
          value: value,
          ref: inputRef,
          readOnly: couponLoading,
          $fullWidth: fullWidth,
          onChange: e => onChange(e.target.value),
          onFocus: () => {
            setIsFocused(true);
          },
          onBlur: () => setIsFocused(false),
          "aria-label": t('coupon-input.placeholder', 'Your coupon'),
          "aria-required": false
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.default, {
        type: "submit",
        width: "auto",
        testid: "redeem-btn",
        children: [couponLoading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
          buttonLoader: true,
          color: "#ffffff"
        }), !couponLoading && isOpen && t('coupon-input.redeem', 'Redeem'), !couponLoading && !isOpen && t('coupon-input.redeem-coupon', 'Redeem coupon')]
      })]
    }), showCouponMessage && isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CouponInputStyled.MessageStyled, {
      $showMessage: true,
      $messageType: messageType,
      children: t(translationKey || '', message)
    })]
  });
};
var _default = exports.default = CouponInput;